import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const BrightSpaceValenceApiWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="brightSpaceValenceApiWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={form.formState.errors.name?.message}
      />
      <FormField
        controlId="brightSpaceValenceApiWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={form.formState.errors.type?.message}
      />
      <FormField
        controlId="brightSpaceValenceApiWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="brightSpaceValenceApiWriterFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="brightSpaceValenceApiWriterFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="brightSpaceValenceApiWriterFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.onError?.message}
      >
        <option value="">Select On Error</option>
        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>
      <FormField
        controlId="brightSpaceValenceApiWriterFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter path"
        required
        error={form.formState.errors.properties?.path?.message}
      />
      <FormField
        controlId="brightSpaceValenceApiWriterFormSleepInMilliSeconds"
        label="sleepInMilliSeconds"
        name="properties.sleepInMilliSeconds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        error={errors?.properties?.sleepInMilliSeconds?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default BrightSpaceValenceApiWriterForm;
